<template>
	<v-footer
		fixed app
		class="update-footer warning px-2 py-1"
		v-if="version_deprecated">
		<v-spacer></v-spacer>
		<v-icon size="32">info</v-icon>
		<span class="headline ml-2">
			Mise à jour disponible
		</span>
		<span class="ml-3">
			Enregistrez votre travail en cours puis actualisez l'application
		</span>
		<v-btn
			small depressed
			color="white warning--text"
			@click="reload()"
			class="ml-4">
			<v-icon class="mr-1">autorenew</v-icon>
			actualiser
		</v-btn>
		<v-spacer></v-spacer>
	</v-footer>
</template>

<script>
import axios from 'axios'
export default {
	data () {
		return {
			version_deprecated: false,
			loop_interval: null,
			is_focused: true
		}
	},
	methods: {
		reload () {
			window.location.href = window.location.href
		},
		checkVersion () {
			if (this.version_deprecated) return
			axios({ baseURL: window.appConfig._$92sql3, method: 'get' })
				.then(response => {
					let parser = new DOMParser()
					let htmlDoc = parser.parseFromString(response.data, 'text/html')
					let liveVersion = null
					let liveNode = htmlDoc.getElementById('gravity-version')
					if (liveNode) {
						liveVersion = liveNode.getAttribute('version')
					}

					let currentVersion = null
					let currentNode = window.document.getElementById('gravity-version')
					if (currentNode) {
						currentVersion = currentNode.getAttribute('version')
					}

					this.version_deprecated = liveVersion !== currentVersion
				})
				.catch(error => {
					console.log(error)
				})
		}
	},
	mounted () {
		window.onblur = () => { this.is_focused = false }
		window.onfocus = () => {
			this.is_focused = true
			this.checkVersion()
		}
		this.checkVersion()
		this.loop_interval = setInterval(() => {
			if (this.is_focused) this.checkVersion()
		}, 5 * 1000 * 60)
	},
	beforeDestroy () {
		clearInterval(this.loop_interval)
	}
}
</script>

<style lang="stylus" scoped>

.update-footer
	z-index: 100
</style>



// WEBPACK FOOTER //
// src/app_version_checker.vue